export const cloudname = process.env.REACT_APP_CLOUD_NAME
export const uploadPreset = process.env.REACT_APP_UPLOAD_PRESET